import PropTypes from 'prop-types'
// import React, { Component } from 'react'
import React from 'react'
// import styles from './Styles.jsx'
import {
//   Button,
//   Container,
  // Divider,
  // Grid,
  // Header,
  // Icon,
  // Image,
  // List,
//   Menu,
  // Segment,
  // Visibility,
} from 'semantic-ui-react'

import DesktopContainer from './DesktopContainer.jsx'
import MobileContainer from './MobileContainer.jsx'



const ResponsiveContainer = ({ children }) => (
    <div>
      <DesktopContainer>{children}</DesktopContainer>
      <MobileContainer>{children}</MobileContainer>
    </div>
  )
  
  ResponsiveContainer.propTypes = {
    children: PropTypes.node,
  }

  export default ResponsiveContainer


// WEBPACK FOOTER //
// ./src/components/ResponsiveContainer.jsx